import { call, put, takeLatest, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import ProductsEndpoint from '../../persistence/ProductsEndpoint'
import { actions as productActions } from '../products'

const createProduct = { ...defineTypes('CREATE_PRODUCT') }

export const initialState = {
  started: false,
  loading: false,
  loaded: false
}

export const actions = {
  submitProduct () {
    return { type: 'SUBMIT_PRODUCT_FORM' }
  },
  setImageUrl (image_url) {
    return { type: 'SET_IMAGE_URL', image_url: image_url }
  }
}

export const reducer = (state = initialState, action ) => {
  switch (action.type) {
    case createProduct.REQUEST:
      return { ...state, started: true, loading: true }
    case createProduct.FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case createProduct.SUCCESS:
      return { ...state, loading: false, loaded: true }
    case 'SET_IMAGE_URL':
      return { ...state, image_url: action.image_url }
    default:
      return state
  }
}

export const selectors = {
  new_product_form: (store) => {
    return store.form.new_product
  },
  product_image_url: (store) => {
    return store.new_product['image_url'] || null
  },
  errors: (store) => {
    return store.new_product['errors']
  }
}

export function * newProductSaga (action) {
  try {
    yield takeLatest(createProduct.SUCCESS, productSuccess)
    const form = yield select(selectors.new_product_form)
    const image_url = yield select(selectors.product_image_url)
    const new_product = form['values']
    new_product['image_url'] = image_url || null
    const new_product_response = yield call(reduxFetch, ProductsEndpoint.new(new_product))
    if ( new_product_response['data'] ) {
      yield put({ type: createProduct.SUCCESS, new_product: new_product_response.data })
    } else {
      yield put({ type: createProduct.FAILURE, errors: new_product_response.errors })
    }
  } catch (error) {
    yield put({ type: createProduct.FAILURE, errors: error })
  }
}

export function * productSuccess (action) {
  try {
    yield call(productActions.getProducts)
    yield put(push('/products'))
  } catch (error) {
    yield put({type: createProduct.FAILURE, errors: error })
  }
}

export function * rootSaga () {
  yield takeLatest('SUBMIT_PRODUCT_FORM', newProductSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/products/new.js